import { render, staticRenderFns } from "./CertificadosDigitais.vue?vue&type=template&id=dfbf52f4&scoped=true"
import script from "./CertificadosDigitais.vue?vue&type=script&lang=js"
export * from "./CertificadosDigitais.vue?vue&type=script&lang=js"
import style0 from "./CertificadosDigitais.vue?vue&type=style&index=0&id=dfbf52f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbf52f4",
  null
  
)

export default component.exports